/* React Calendar Modal Component */

import React, { useState } from 'react';
import Modal from '@carvana/showroom-modal';
// @ts-ignore
import './DatePicker.css';
import { Calendar } from 'react-modern-calendar-datepicker';
import CalendarIcon from '../../../assets/CalendarIcon';
import { useDualEventTracking } from '../../../utils/useDualEventTracking';
import {
  CalendarModalContent,
  CalendarTitle,
  HR,
  ConfirmButton,
} from './CalendarModal.styles';

/**
 *  Calendar Modal Component
 * @component CalendarModal
 * @param {object} dateOptions - contains object props with  default date, minimum date and maximum date
 * @param {object} dateOptions.defaultDate - contains object with year, month and date
 * @param {number} dateOptions.defaultDate.year - year
 * @param {number} dateOptions.defaultDate.month - month
 * @param {number} dateOptions.defaultDate.date - date
 * @param {object} dateOptions.minimumDate - optional, follows the same object patters as defaultDate object
 * @param {object} dateOptions.maximumDate - optional, follows the same object patters as defaultDate object
 * @param {boolean} openModal - boolean to show or hide calendar modal
 * @param {function} toggleCalendarModal - callback to update modal show/hide state
 * @param {function} handleDateChange - callback to update selected date
 */

const CalendarModal = ({
  dateOptions,
  openModal,
  toggleCalendarModal,
  handleDateChange,
}: any) => {
  const { defaultDate, minimumDate = {}, maximumDate = {} } = dateOptions;
  const [selectedDay, setSelectedDay] = useState(defaultDate);
  const langPack = {
    title: 'Schedule Payment',
    calendarTitle: 'Select a date for your payment to Bridgecrest',
  };
  const { trackEvent } = useDualEventTracking();

  const handleDateSelection = () => {
    const { year, month, day } = selectedDay;
    handleDateChange(`${year}-${month}-${day}`);
    trackEvent('Calendar Screen - Confirm Date - Tap');
    toggleCalendarModal();
  };

  return (
    <>
      <Modal
        headerText={langPack.title}
        closeModal={toggleCalendarModal}
        isOpen={openModal}
        testHook="date-picker-modal"
        mode="light"
        portalDivId="date-picker"
      >
        <CalendarModalContent>
          <CalendarIcon />
          <CalendarTitle>{langPack.calendarTitle}</CalendarTitle>
          <HR />
          <Calendar
            value={selectedDay}
            onChange={setSelectedDay}
            colorPrimary="#00619E"
            minimumDate={minimumDate}
            maximumDate={maximumDate}
            locale="en"
          />
          <ConfirmButton id="confirmDateBtn" onClick={handleDateSelection}>
            Confirm Date
          </ConfirmButton>
        </CalendarModalContent>
      </Modal>
    </>
  );
};

export default CalendarModal;
